import { faCommentDots } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { buttonVariants, cn } from "frontend-components";
import { useTranslation } from "react-i18next";

const UPVOTY_FEEDBACK_URL = "https://compendia.upvotyfeedback.com";

export function FeedbackLink() {
    const { t } = useTranslation();

    return (
        <a
            href={UPVOTY_FEEDBACK_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={cn(
                buttonVariants({ variant: "outline" }),
                "gap-2 rounded-full border-compendia-border bg-compendia-card px-3.5 py-[5px] text-xs font-medium text-compendia-gray-60 transition-colors duration-200 hover:border-compendia-foreground hover:text-compendia-foreground",
            )}
        >
            <FontAwesomeIcon icon={faCommentDots} />
            <span className="sr-only sm:not-sr-only">{t("dashboard.giveFeedback")}</span>
            <span className="sr-only">{t("dashboard.opensInNewTab")}</span>
        </a>
    );
}
